export default __webpack_public_path__ + "static/media/checklist.f19d760c.svg";